import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { UserContext } from "@/components/User";
import { acceptAllCompanyInvitations } from "@/data/companies-invitations";
import { acceptAllInvitations } from "@/data/invitations";
import { IPersonalInvitation } from "@/data/personal-invitations";
import { refresh } from "@/data/session";
import { putUser } from "@/data/users";
import { SessionContext } from "@/infrastructure/Session";
import { router } from "@/views/router";

export const useOnboardingAcceptProfiles = (companyId?: number) => {
  const User = useContext(UserContext);
  const Session = useContext(SessionContext);
  const history = useHistory();
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const accept = async () => {
      if (companyId) {
        await acceptAllCompanyInvitations({ companyId });
      } else {
        await acceptAllInvitations();
      }

      const user = User.sessionUser;
      if (!user.onboardingDisplayed) {
        await putUser({ userId: user.id }, { ...user, onboardingDisplayed: true });
        User.updateContextUser({ ...user, onboardingDisplayed: true });
      }
      setAccepted(true);
    };
    accept();
  }, []);

  const handleContinueClick = async (
    profileId: number,
    recommendedJobRequestId?: IPersonalInvitation["recommendedJobRequestId"],
    jobRequestApplication?: IPersonalInvitation["jobRequestApplication"],
  ) => {
    const sessionUser = await refresh();

    const profile = sessionUser.consultantProfiles.find(cp => cp.id === profileId)!;

    Session.update(sessionUser, () => {
      if (!profile.blocked) {
        User.setConsultantProfileContext(profileId);
      } else {
        User.setConsultantProfileContext(undefined);
      }

      let path = router.get("consultant-profiles.detail", {
        consultantProfileId: profileId,
      }).path;

      if (recommendedJobRequestId) {
        if (jobRequestApplication) {
          path = router.get("job-applications", { jobApplicationId: jobRequestApplication.id }).path;
        } else {
          path = router.get("job-requests.detail", {
            jobRequestId: recommendedJobRequestId,
          }).path;
        }
      }

      history.push(path);
    });
  };

  return {
    handleContinueClick,
    accepted,
  };
};
